/**
 * @param key
 * @param defaultTr
 * @param var_args {...*}
 */
export default function tr(key, defaultTr, var_args = undefined) {
    if (key) {
        return AppTranslations.translate(...arguments);
    }
}
if (window) {
    window["$tr"] = tr;
}

export function runtimeTr(key, defaultTr, var_args = undefined) {
    if (key) {
        return AppTranslations.translateUnchecked(...arguments);
    }
}

export function copyFieldWithTranslation(sourceObject, sourceFieldName, targetObject, targetFieldName) {
    let translationCopy = {...targetObject._translations};
    if (!sourceObject._translations) {
        return;
    }
    Object.entries(sourceObject._translations).forEach(([key, val]) => {
        let el = val[sourceFieldName];
        if (el !== null) {
            if (!translationCopy[key]) {
                let newMap = {};
                newMap[targetFieldName] = el;
                translationCopy[key] = newMap;
            } else {
                translationCopy[key][targetFieldName] = el;
            }
        }
    });
    targetObject._translations = translationCopy;
}

if (window) {
    window["$copyFieldWithTranslation"] = copyFieldWithTranslation;
}